import { useSearchParams as useReactRouterSearchParams } from "react-router-dom";

export const useSearchParams = () => {
  const [_searchParams, _setSearchParams] = useReactRouterSearchParams();
  const searchParams = Object.fromEntries(_searchParams.entries()) as {
    [key: string]: string | undefined;
  };

  const getSearchParam = (key: string) => {
    return searchParams[key] as string | undefined;
  };

  const setSearchParams = (searchParams: {
    [key: string]: string | number | boolean | undefined;
  }) => {
    const cleanSearchParams: { [key: string]: string } = {};

    for (const [key, value] of Object.entries(searchParams)) {
      if (value === undefined || (key === "page" && (value === 1 || value === "1"))) {
        continue;
      } else if (typeof value === "boolean" && value === true) {
        cleanSearchParams[key] = "true";
      } else if (typeof value === "number") {
        cleanSearchParams[key] = String(value);
      } else if (typeof value === "string" && value !== "") {
        cleanSearchParams[key] = value;
      }
    }

    _setSearchParams(cleanSearchParams);
  };

  const setSearchParam = (key: string, value: string | number | boolean | undefined) => {
    setSearchParams({ ...searchParams, [key]: value });
  };

  const appendSearchParams = (append: { [key: string]: string | number | boolean | undefined }) => {
    setSearchParams({ ...searchParams, ...append });
  };

  return {
    searchParams,
    getSearchParam,
    setSearchParam,
    setSearchParams,
    appendSearchParams,
  };
};
